import React, { useState, useEffect } from "react";
import Commonheader from "./Commonheader";
import useAxios from "../hooks/useAxios";
import { Select } from "antd";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";

function Permission(props) {
  const [loading, sendRequest] = useAxios();
  const [user_role, setuser_role] = useState();
  const [user_role_list, setuser_role_list] = useState();
  const [functionality_list, setfunctionality_list] = useState();
  const [functionality, setfunctionality] = useState();
  const [isError, setisError] = useState();
  const [isErrorMessage, setisErrorMessage] = useState();
  const [EditRole, setEditRole] = useState();
  const [isEditRole, issetEditRole] = useState(false);
  const [isEditFunctionality, setisEditFunctionality] = useState(false);
  const [EditRoleStatus, setEditRoleStatus] = useState();
  const [EditFunctionalityStatus, setEditFunctionalityStatus] = useState();
  const [role_functionalitylist, setrole_functionalitylist] = useState();
  const [role_functionality_id, setrole_functionality_id] = useState();

  useEffect(() => {
    get_user_role();
  }, []);
  const save_createrole = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "save_role");
    form.append("rolename", user_role);
    const response = await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setisError(true);
        setisErrorMessage(response.message);
        setuser_role("");
        get_user_role();
      }
    );
  };
  const update_role = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "update_role");
    form.append("rolename", user_role);
    form.append("status", EditRoleStatus);
    const response = await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setisError(true);
        setisErrorMessage(response.message);
        setuser_role("");
        get_user_role();
      }
    );
  };
  const save_functionality = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "save_role_functionality");
    //form.append("role_id", role_functionality_id);
    form.append("role_id", user_role);
    form.append("functionality_arr", JSON.stringify(functionality));
    const response = await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setisError(true);
        setisErrorMessage(response.message);
        setrole_functionality_id();
        //setuser_role();
        //setfunctionality();
        //get_functionality();
      }
    );
  };
  const get_user_role = () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "fetch_role");
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setuser_role_list(response.roles);
        setuser_role("");
        //setjiraTicket(response);
      }
    );
  };
  const get_role_functionality = (e) => {
    setrole_functionalitylist();
    setfunctionality();
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "fetch_role_functionality");
    form.append("role_id", e);
    sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        if (response.functionality_role_mapping) {
          setrole_functionalitylist(response.functionality_role_mapping);
          const functionalityIds = response.functionality_role_mapping.flatMap(
            (item) =>
              item.functionality_arr.map(
                (innerItem) => innerItem.functionality_id
              )
          );

          console.log("functionalityIds", functionalityIds);
          setfunctionality(functionalityIds);
          setrole_functionality_id(
            response.functionality_role_mapping[0].role_functionality_id
          );
        } else {
          setrole_functionalitylist();
          setfunctionality();
        }
        //setjiraTicket(response);
      }
    );
  };
  const get_functionality = () => {
    if (!functionality_list) {
      let apitoken = localStorage.getItem("api_token");
      const form = new FormData();
      form.append("flag", "fetch_functionality");
      sendRequest(
        {
          url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
          method: "POST",
          data: form,
          headers: {
            "api-token": apitoken,
          },
        },
        (response) => {
          setfunctionality_list(response.functionality);
          setuser_role("");
          //setjiraTicket(response);
        }
      );
    }
  };
  const update_functionality = async () => {
    let apitoken = localStorage.getItem("api_token");
    const form = new FormData();
    form.append("flag", "update_role_functionality");
    form.append("rolename", user_role);
    form.append("status", EditFunctionalityStatus);
    const response = await sendRequest(
      {
        url: `${process.env.REACT_APP_BASE_URL}/permission/data`,
        method: "POST",
        data: form,
        headers: {
          "api-token": apitoken,
        },
      },
      (response) => {
        setisError(true);
        setisErrorMessage(response.message);
        //get_functionality();
        setuser_role("");
      }
    );
  };
  return (
    <div className="container">
      <Commonheader pagetitle={"Permission"} props={props} />
      {loading && (
        <div class="load-4">
          <div class="ring-1"></div>
        </div>
      )}
      <div
        className={
          isError
            ? "modal fade show d-block mymodal"
            : "modal fade bd-example-modal-sm"
        }
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="confirm-box"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setisError(false);
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="popuperrtext">{isErrorMessage}</p>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div id="accordion">
          <div class="card">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <button
                  class="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                  onClick={() => setuser_role("")}
                >
                  User Role
                </button>
              </h5>
            </div>

            <div
              id="collapseOne"
              class="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div class="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="Create User Role"
                      onChange={(e) => setuser_role(e.target.value)}
                      value={user_role}
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary form-control"
                      onClick={() => save_createrole()}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user_role_list &&
                        user_role_list.map((roles, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{roles.rolename}</td>
                            <td>
                              {index == EditRole ? (
                                <>
                                  <select
                                    className="form-control"
                                    onChange={(e) =>
                                      setEditRoleStatus(e.target.value)
                                    }
                                  >
                                    <option value="A">Active</option>
                                    <option value="X">De Active</option>
                                  </select>
                                </>
                              ) : (
                                "Active"
                              )}
                            </td>
                            <td>
                              {isEditRole ? (
                                <>
                                  <button
                                    className="btn btn-primary mr-2"
                                    onClick={() => {
                                      update_role();
                                      issetEditRole(false);
                                    }}
                                  >
                                    <CheckOutlined />
                                  </button>
                                  <button
                                    className="btn btn-primary mr-2"
                                    onClick={() => {
                                      setEditRole("");
                                      issetEditRole(false);
                                    }}
                                  >
                                    <CloseOutlined />
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="btn btn-primary mr-1"
                                  onClick={() => {
                                    setEditRole(index);
                                    setuser_role(roles.rolename);
                                    issetEditRole(true);
                                  }}
                                >
                                  <EditOutlined disabled={EditRole > 0} />
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="headingTwo">
              <h5 class="mb-0">
                <button
                  class="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                  onClick={() => get_functionality()}
                >
                  Functionality Role Mapping
                </button>
              </h5>
            </div>
            <div
              id="collapseTwo"
              class="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div class="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <Select
                      showSearch
                      className="form-control text-center"
                      onChange={(e) => {
                        get_role_functionality(e);
                        setuser_role(e);
                      }}
                      defaultValue={user_role}
                      placeholder="Select Role"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        user_role_list &&
                        user_role_list.map((roles) => {
                          return {
                            label: roles.rolename,
                            value: roles.roleid,
                          };
                        })
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    {console.log("functionality", functionality)}
                    <Select
                      showSearch
                      mode="multiple"
                      className="form-control text-center"
                      onChange={(e) => {
                        setfunctionality(e);
                      }}
                      value={functionality}
                      placeholder="Select Functionality"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option && option.label
                          ? option.label.toLowerCase()
                          : ""
                        ).includes(input.toLowerCase())
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA && optionA.label
                          ? optionA.label.toLowerCase()
                          : ""
                        ).localeCompare(
                          optionB && optionB.label
                            ? optionB.label.toLowerCase()
                            : ""
                        )
                      }
                      options={
                        functionality_list &&
                        functionality_list.map((functionality) => {
                          return {
                            label: functionality.function_name,
                            value: functionality.functionality_id,
                          };
                        })
                      }
                    />
                  </div>
                  <div className="col-md-2">
                    <button
                      className="btn btn-primary form-control"
                      onClick={() => save_functionality()}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Functionality</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {role_functionalitylist &&
                            role_functionalitylist.map((mapping) =>
                              mapping.functionality_arr.map(
                                (func) => func.functionality_name + ", "
                              )
                            )}
                        </td>
                        <td>
                          {functionality &&
                            (isEditFunctionality ? (
                              <>
                                <select
                                  className="form-control"
                                  onChange={(e) =>
                                    setEditFunctionalityStatus(e.target.value)
                                  }
                                >
                                  <option value="A">Active</option>
                                  <option value="X">De Active</option>
                                </select>
                              </>
                            ) : (
                              "Active"
                            ))}
                        </td>
                        <td>
                          {functionality &&
                            (isEditFunctionality && role_functionalitylist ? (
                              <>
                                <button
                                  className="btn btn-primary mr-2"
                                  onClick={() => {
                                    update_functionality();
                                    setisEditFunctionality(false);
                                  }}
                                >
                                  <CheckOutlined />
                                </button>
                                <button
                                  className="btn btn-primary mr-2"
                                  onClick={() => {
                                    setEditRole("");
                                    setisEditFunctionality(false);
                                  }}
                                >
                                  <CloseOutlined />
                                </button>
                              </>
                            ) : (
                              <button
                                className="btn btn-primary mr-1"
                                onClick={() => {
                                  //setEditRole(index);
                                  //setuser_role(roles.rolename);
                                  setisEditFunctionality(true);
                                }}
                              >
                                <EditOutlined />
                              </button>
                            ))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="card">
            <div class="card-header" id="headingThree">
              <h5 class="mb-0">
                <button
                  class="btn btn-link collapsed"
                  data-toggle="collapse"
                  data-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Collapsible Group Item #3
                </button>
              </h5>
            </div>
            <div
              id="collapseThree"
              class="collapse"
              aria-labelledby="headingThree"
              data-parent="#accordion"
            >
              <div class="card-body">
                Anim pariatur cliche reprehenderit, enim eiusmod high life
                accusamus terry richardson ad squid. 3 wolf moon officia aute,
                non cupidatat skateboard dolor brunch. Food truck quinoa
                nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua
                put a bird on it squid single-origin coffee nulla assumenda
                shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
                wes anderson cred nesciunt sapiente ea proident. Ad vegan
                excepteur butcher vice lomo. Leggings occaecat craft beer
                farm-to-table, raw denim aesthetic synth nesciunt you probably
                haven't heard of them accusamus labore sustainable VHS.
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Permission;
